import { render, staticRenderFns } from "./TeacherCourseUnitList.vue?vue&type=template&id=821621e4&scoped=true"
import script from "./TeacherCourseUnitList.vue?vue&type=script&lang=js"
export * from "./TeacherCourseUnitList.vue?vue&type=script&lang=js"
import style0 from "./TeacherCourseUnitList.vue?vue&type=style&index=0&id=821621e4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "821621e4",
  null
  
)

export default component.exports